<form id="formAssocAccesInterventions" name="formAssocAccesInterventions" class="form-horizontal">
	<input type="text"
		class="form-control"
		[formControl]="filterInput"
		placeholder="Saisir du texte pour filtrer les opérations et demandes d'intervention"
		/>
	<br/>
   	<div class="text-center folding-buttons">
   		<button class="btn btn-xs btn-primary" (click)="foldAll()">
   			<i class="fa-regular fa-square-minus"></i>Tout replier
		</button>
   		<button class="btn btn-xs btn-primary" (click)="unfoldAll()">
   			<i class="fa-regular fa-square-plus"></i>Tout déplier
		</button>
   	</div>
	<div class="acces-operation-binder">
		<div *ngFor="let acte of actes" >
	    	<pannel *ngIf="(acte.id && acteVisible[acte.id])"
	    		[title]="acte.libelle"
	    		[expandable]="true"
	    		[folded]="acte.folded"
	    		(foldedChange)="toggle(acte.id)"
				[headerTemplate]="acte.children.length === 0 && accesRef.ouvragesDto.length === 1 ? pannelHeaderN0WithCheckbox : pannelHeader" >
				
				<ng-container [ngTemplateOutlet]="(acte.children.length === 0) ? hasNoChildren : hasChildren"
					[ngTemplateOutletContext]="{ data: acte }" ></ng-container>
			    <ng-template #pannelHeaderN0WithCheckbox let-title="title" >
			    	<label class="pannel-header-title">
						<input type="checkbox" id="newAssoc_{{ accesRef.ouvragesDto[0].nom }}_{{ acte.code }}" [(ngModel)]="pendingOperations[acte.id + '#' + accesRef.ouvragesDto[0].id]" 
							(ngModelChange)="onCheckNew($event, acte, accesRef.ouvragesDto[0])" [ngModelOptions]="{standalone: true}" />
						<span>{{ title }}</span>
					</label>
				</ng-template>

			</pannel>
		</div>
		<div *ngIf="shouldShowNotifPannel()">
	    	<pannel [title]="'NOTIFICATIONS'" [expandable]="true" [folded]="foldNotificationPannel" [headerTemplate]="pannelHeader">
				<ng-container *ngFor="let notification of notifications; let index = index">
					<label class="notification" *ngIf="shouldShowNotif(notification)">
						<input type="checkbox"
							name="wo_{{index}}_{{ notification.notificationNumber }}" 
							[(ngModel)]="notification.alreadyBound"
							(ngModelChange)="onCheckNotification($event, notification)"
							/>
						<span>Lier à la notification n° <b class="notificationNumber">
							{{ notification.notificationNumber }}</b>"{{ notification.notificationDesc }}" 
							({{ notification.status }} : {{ notification.statusText }}) 
							sur l'ouvrage {{ notification.ouvrageNom }} à partir du {{ notification.notificationDate | localDateTimeToDate: false | date : 'dd/MM/yyyy' }}
						</span>
					</label>
				</ng-container>
			</pannel>
		</div>
		<div *ngIf="shouldShowWoPannel()">
	    	<pannel [title]="'WORK ORDERS'" [expandable]="true" [folded]="foldWorkOrderPannel"  [headerTemplate]="pannelHeader">
				<ng-container *ngFor="let wo of workorders; let index = index">
					<label class="workorder" *ngIf="shouldShowWorkOrder(wo)">
						<input type="checkbox"
							name="wo_{{index}}_{{ wo.workOrder }}" 
							[(ngModel)]="wo.alreadyBound"
							(ngModelChange)="onCheckWorkOrder($event, wo)"
							/>
						<span>Lier au WorkOrder n° <b class="woNumber">
							{{ wo.workOrder }}</b>"{{ wo.workOrderDesc }}" 
							({{ wo.status }} : {{ wo.statusText }}) 
							sur l'ouvrage {{ wo.ouvrageNom }} à partir du {{ wo.plannedStartDate | localDateTimeToDate: false | date : 'dd/MM/yyyy' }}
						</span>
					</label>
				</ng-container>
			</pannel>
		</div>
	</div>
</form>
<form id="formAssocAccesInterventions" name="formAssocAccesInterventions" class="form-horizontal" *ngIf="actes.length === 0 && !shouldShowNotifPannel() && !shouldShowWoPannel()">
	<h4><b>Aucune opération à distance possible </b></h4>
</form>

<ng-template #pannelHeader let-title="title" let-folded="folded" >
	<div class="pannel-header-content">
		<i [ngClass]="['fa', (folded ? 'fa-regular fa-square-plus' : 'fa-regular fa-square-minus'), 'collapsable']" ></i>
		<h4>{{ title }}</h4>
	</div>
</ng-template>

<ng-template #hasChildren let-acte="data">
	<div *ngFor="let child of acte.children" >
		<pannel *ngIf="child.id && acteVisible[child.id]"
			[title]="child.libelle"
			[expandable]="true"
			[folded]="child.folded"
			(foldedChange)="toggle(child.id)"
			[pannelClass]="'niveau' + child.niveau"
			[headerTemplate]="child.children.length === 0 && accesRef.ouvragesDto.length === 1 ? pannelHeaderWithCheckbox : pannelHeader"
			>
			<ng-container
				[ngTemplateOutlet]="(child.children.length === 0) ? hasNoChildren : hasChildren"
				[ngTemplateOutletContext]="{ data: child }"
				>
		    </ng-container>
		    <ng-template #pannelHeaderWithCheckbox let-title="title" >
		    	<label class="pannel-header-title">
					<input type="checkbox" id="newAssoc_{{ accesRef.ouvragesDto[0].nom }}_{{ child.code }}" [(ngModel)]="pendingOperations[child.id + '#' + accesRef.ouvragesDto[0].id]" (ngModelChange)="onCheckNew($event, child, accesRef.ouvragesDto[0])" />
					<span>{{ title }}</span>
				</label>
			</ng-template>
		</pannel>
	</div>
</ng-template>

<ng-template #hasNoChildren let-acte="data">
<div *ngIf="accesRef.ouvragesDto.length > 1">
	<div *ngFor="let ouvrage of accesRef.ouvragesDto; let index = index">
		<label class="newOperation">
			<input type="checkbox" name="newAssoc_{{ ouvrage.nom }}_{{ acte.code }}" [(ngModel)]="pendingOperations[acte.id + '#' + ouvrage.id]" (ngModelChange)="onCheckNew($event, acte, ouvrage)" /> 
			<i>Associer cet acte à l'ouvrage {{ ouvrage.nom }}</i>
		</label>
	</div>
</div>
</ng-template>